import React, {useState} from 'react';
import { useTranslate } from '@tolgee/react';
import { useDispatch, useSelector } from 'react-redux';

import AnalyzeImageAction from './analyzeImageAction';
import CreatePostUrlAction from './createPostUrlAction';
import RewriteTextAction from './rewriteTextAction';
import LomavisAiAssistantUpgradeHint from "../upgradeHint";
import {textIsUrl} from "../../../config/buttonsValidatorsFunctions";
import toast from "react-hot-toast";
import {
    aiAssistantToggleMainActionUrlField,
    sendAiAssistantQuickAction
} from "../../../../../redux/slices/lomavisCreator/lomavisCreator";
import {MAIN_QUICK_ACTIONS} from "../constants";
import GenerateTextAction from "./generateText";

const MainQuickActions: React.FC = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

    const CREATE_POST_URL_ACTION = MAIN_QUICK_ACTIONS.find(
        (item) => item.action === 'createPostUrl'
    );

    const [url, setUrl] = useState('');

  // Pull these values from your Redux store:
  const {
    useSeparateMediaFiles,
    useSeparateTextFields,
    aiAssistant: {
      aIQuota: { advanced_ai_usage_available, advanced_ai_usage_used },
        ui: { showMainActionUrlInput },
        conversation: { messageSettings }
    },
    postData
  } = useSelector((state: any) => state.lomavisCreator);

    const handleCreatePostUrlClick = (): void => {
        // check if url does not start with http or https add it
        const finalUrl =
            !url.startsWith('http://') && !url.startsWith('https://')
                ? `https://${url}`
                : url;
        if (!textIsUrl(finalUrl)) {
            toast.error(t('lomavis.branding.mainActions.invalidUrl'), {
                duration: 2000,
                position: 'top-right'
            });
            return;
        }

        dispatch(
            sendAiAssistantQuickAction(CREATE_POST_URL_ACTION, {
                url: finalUrl,
                ...messageSettings
            }) as any
        );
    };

  return (
      <div className={"d-flex flex-column"}>
          <div className={"d-flex flex-row justify-content-start"}>


              {/*{ advanced_ai_usage_available !== null && advanced_ai_usage_available <= advanced_ai_usage_used && (*/}
              {/*    <LomavisAiAssistantUpgradeHint*/}
              {/*        text={"lomavisCreator.aiAssistant.noAdvancedAIQuota"}*/}
              {/*    />*/}
              {/*)}*/}

              <div className={"me-2"}>
                  <GenerateTextAction
                      t={t}
                      dispatch={dispatch}
                  />
              </div>

              {/* Analyze Image Block */}
              <div className={"me-2"}>
                  <AnalyzeImageAction
                      t={t}
                      dispatch={dispatch}
                      useSeparateMediaFiles={useSeparateMediaFiles}
                      availableTokens={advanced_ai_usage_available}
                      usedTokens={advanced_ai_usage_used}
                      postData={postData}
                      advancedDataButton={true}
                  />
              </div>


              {/* Create Post from URL Block */}
              <div className={"me-2"}>
                  <CreatePostUrlAction
                      t={t}
                      dispatch={dispatch}
                      availableTokens={advanced_ai_usage_available}
                      usedTokens={advanced_ai_usage_used}
                      url={url}
                      advancedDataButton={true}
                  />
              </div>


              {/* Rewrite Text Block */}
              <div className={"me-2"}>
                  <RewriteTextAction
                      t={t}
                      dispatch={dispatch}
                      useSeparateTextFields={useSeparateTextFields}
                      availableTokens={advanced_ai_usage_available}
                      usedTokens={advanced_ai_usage_used}
                      postData={postData}
                      advancedDataButton={true}
                  />
              </div>

          </div>
          {showMainActionUrlInput && (
              <div className={"d-flex flex-column mt-2"}>
                  <div>
                      <label className={"label text-muted"}>
                            {t('lomavis.branding.mainActions.urlInputLabel')}
                      </label>
                      <input
                          // support submit with enter key
                          onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                  handleCreatePostUrlClick();
                              }
                          }}
                          type="text"
                          autoFocus
                          className="form-control mt-2 form-control-sm"
                          placeholder={t('lomavis.branding.mainActions.urlInputField')}
                          value={url}
                          onClick={(e) => {
                              e.stopPropagation();
                          }}
                          onChange={(e) => {
                              setUrl(e.target.value);
                          }}
                      />
                  </div>

                  <div className={"d-flex justify-content-end mt-2"}>
                      <div>
                          <div className={"btn btn-secondary btn-sm me-2"} onClick={(e) => {dispatch(aiAssistantToggleMainActionUrlField())}}>{t("lomavis.branding.mainActions.textFromUrlCloseButton")}</div>
                          <div className={"btn btn-primary btn-sm"} onClick={handleCreatePostUrlClick}>{t("lomavis.branding.mainActions.textFromUrlGoButton")}</div>
                      </div>
                  </div>

              </div>
          )}

      </div>

  );
};

export default MainQuickActions;
